//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductDocumentItem from "~/components/product/main-product-card/ProductDocumentItem";

export default {
  name: "SectionDescriptionDocuments",

  data: function () {
    return {
      activeTab: "description",
      isSmallDescription: false,
      isShowButtonMoreDescription: false
    }
  },

  components: {
    DescriptionProductCard: () => import('~/components/product/main-product-card/DescriptionProductCard'),
    ProductDocumentItem
  },

  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  computed: {
    isShowDescription: function () {
      return Boolean(this.product?.shortDescription || this.product?.description || this.additionalTextDescription);
    },
    isShowDocumentsTab: function () {
      return Boolean(this.getDocumentsList.length > 0)
    },

    getDocumentsList() {
      return this.product?.files || [];
    },
    howReadRecipe: function () {
      const characteristics = this.product?.characteristics?.[0]?.characteristics || [];
      return characteristics.find((t) => t.slug === "prescription-contact-lenses")?.values?.[0]?.value
    },
    additionalTextDescription: function () {
      return this.product?.dynamicFields?.additional_description || ""
    }
  },

  mounted: function () {
    this.initFunctionMoreDescription();
  },

  methods: {
    initFunctionMoreDescription: function () {
      const fullHeight = this.$refs.refDescription.getBoundingClientRect();
      if (fullHeight.height <= 72) {
        return
      }

      this.isShowButtonMoreDescription = true;
      this.isSmallDescription = true;
    },
    changeSmallDescription: function () {
      this.isSmallDescription = !this.isSmallDescription;
    }
  }
}
